var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5001 32.0615C19.7549 32.0615 19.9626 31.8538 19.9626 31.599V2.579L29.0535 11.6699C29.1438 11.7602 29.2631 11.8054 29.3805 11.8054C29.498 11.8054 29.6172 11.7602 29.7075 11.6699C29.8882 11.4892 29.8882 11.1966 29.7075 11.0159L19.8271 1.1355C19.6465 0.954835 19.3538 0.954835 19.1731 1.1355L9.29273 11.0159C9.11206 11.1965 9.11206 11.4892 9.29273 11.6699C9.47339 11.8506 9.76605 11.8506 9.94675 11.6699L19.0376 2.579V31.599C19.0376 31.8538 19.2454 32.0615 19.5001 32.0615Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9125 15.5975H25.827C25.5723 15.5975 25.3645 15.8052 25.3645 16.06C25.3645 16.3147 25.5723 16.5225 25.827 16.5225H32.9125C35.2069 16.5225 37.075 18.3906 37.075 20.685V32.9125C37.075 35.207 35.2069 37.075 32.9125 37.075H6.0875C3.79308 37.075 1.925 35.207 1.925 32.9125V20.685C1.925 18.3906 3.79308 16.5225 6.0875 16.5225H13.173C13.4277 16.5225 13.6355 16.3147 13.6355 16.06C13.6355 15.8052 13.4277 15.5975 13.173 15.5975H6.0875C3.28179 15.5975 1 17.8793 1 20.685V32.9125C1 35.7183 3.28179 38 6.0875 38H32.9125C35.7182 38 38 35.7183 38 32.9125V20.685C38 17.8793 35.7182 15.5975 32.9125 15.5975Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.1c9a59a2e6ce3f97a0fb9983ab39c0c5.svg";
export { ForwardRef as ReactComponent };